import LogoLargeBlue from '@/assets/logo/logo-large-blue.svg'
import LogoSmallBlue from '@/assets/logo/logo-small-blue.svg'
import { ROUTES } from '@/core/constants/routes'
import { cn } from '@/core/lib/utils/cn'
import {
  getAppSettings,
  getSupportNumber,
} from '@/features/content/providers/server'
import { getTranslations } from 'next-intl/server'
import { Suspense } from 'react'
import { CompanyInfo } from './company-info'
import { FooterList } from './footer-list'

type Props = {
  className?: string
  excludedRoutes?: string[]
}

export async function Footer({ className }: Props) {
  const t = await getTranslations()
  const appSettings = getAppSettings()
  const supportNumber = getSupportNumber()

  return (
    <footer className={cn('relative overflow-hidden', className)}>
      <div className='flex flex-col gap-10 md:gap-4'>
        <div className='flex flex-col justify-between gap-8 md:flex-row md:gap-16 lg:gap-32 xl:gap-48'>
          <div className='flex w-full flex-col gap-4 md:w-52'>
            <LogoLargeBlue />
            <p className='text-navy text-sm'>
              {t('conjunctions.at')} <strong>{t('brand.name')}</strong>,{' '}
              {t('footer.msg')} <strong>{t('brand.name')}</strong>
            </p>
          </div>
          <div className='flex w-full flex-col justify-between gap-8 sm:flex-row'>
            <FooterList
              title={t('footer.stayConnected')}
              items={[
                { label: t('links.about'), href: ROUTES.about },
                { label: t('links.contact'), href: ROUTES.contactUs },
                {
                  label: t('links.support'),
                  href: ROUTES.support,
                  protected: true,
                },
                { label: t('links.blog'), href: ROUTES.blog },
              ]}
            />
            <FooterList
              title={t('footer.more')}
              items={[
                { label: t('links.terms'), href: ROUTES.terms },
                { label: t('links.privacy'), href: ROUTES.privacy },
              ]}
            />
            <FooterList
              title={t('footer.follow')}
              items={[
                {
                  label: t('footer.facebook'),
                  href: 'https://www.facebook.com',
                  target: '_blank',
                },
                {
                  label: t('footer.instagram'),
                  href: 'https://www.instagram.com',
                  target: '_blank',
                },
                {
                  label: t('footer.linkedin'),
                  href: 'https://www.linkedin.com',
                  target: '_blank',
                },
              ]}
            />
          </div>
        </div>

        <Suspense fallback={null}>
          <CompanyInfo
            appSettingsPromise={appSettings}
            supportNumberPromise={supportNumber}
          />
        </Suspense>
        <div className='text-grey-60'>
          <p className='font-light'>
            &copy; {new Date().getFullYear()}{' '}
            <span className='text-red font-normal'>Flat Lane</span>{' '}
            {t('footer.rights')}
          </p>
        </div>
      </div>

      <LogoSmallBlue className='absolute right-0 -bottom-8 -z-10 h-56 w-60 opacity-20 sm:h-72 sm:w-80' />
    </footer>
  )
}
